var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "main-layout"
  }, [_c('div', {
    staticClass: "router-view",
    class: {
      'is-collapse': _vm.collapse,
      'is-less-tablet': _vm.isLessTablet
    }
  }, [_c('coupon-banner'), _c('router-view')], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }